import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import './styles/matrix.css';
import './styles/theme.css';

console.log('🎯 React app is loading...');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

console.log('✅ Root element found');

// Create a container for the matrix effect
const matrixContainer = document.createElement('div');
matrixContainer.className = 'matrix-rain';
document.body.appendChild(matrixContainer);

console.log('✅ React rendering...');

createRoot(rootElement).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);

console.log('✅ React render called');